$(document).ready(function(){
	// Newsletter Header
  $('.newletter_ a, .closer_').click(function(){
  	var form_newletter_ = $('.form_newletter_');
    if(form_newletter_.is(':hidden')){
    	form_newletter_.slideDown();
    }else{
    	form_newletter_.slideUp();
    }
  });
	// Popup Cart 
  
  // Form login
  $('.desktop_log, .btn_close').click(function(){
  	var form_login_  = $('.form_login_ ');
    if(form_login_.is(':hidden')){
    	form_login_.slideDown();
    }else{
    	form_login_.slideUp();
    }
  });
  var s_width = $(window).width();
  $(window).resize(function(){
  	var s_width = $(window).width();
  })
  if  (s_width < 767){
    $('.mobile-nav__sublist-trigger').click(function(){
    	var href_ = $(this).attr('href');
      	window.location.href = href_;
    })
    $(document).on('click','.mobile-nav__sublist-expand',function(e){
    	return false;
    })
  }
  // Height BOdy
  $(window).load(function(){
  	var s_height = $(window).height();
  	$('body,.w_1,.w_2').css('min-height',s_height);
  })  ;
  
  // Sortby on Search
function sortUsingNestedText(parent, childSelector, keySelector) {
    var items = parent.children(childSelector).sort(function(a, b) {
        if(keySelector=='span.price_nomarl span')
        {
          var vA = parseInt($(keySelector, a).text().replace("$",''));
          var vB = parseInt($(keySelector, b).text().replace("$",''));
          return (vA < vB) ? -1 : (vA > vB) ? 1 : 0;
    	}
      	else if(keySelector=='span.date_time_'){
          return new Date( $(a).text() ) > new Date( $(b).text() );
        }
        else
        {
          var vA = $(keySelector, a).text();
          var vB = $(keySelector, b).text();
          return (vA < vB) ? -1 : (vA > vB) ? 1 : 0;
        }
    });
    parent.append(items);
}

$('#sPrice').data("sortKey", "span.price_nomarl span");
$('#sStyle').data("sortKey", ".name_ a");
$('#sDate').data("sortKey", ".date_time_");

/* sort on button click */
$(".btnSort").click(function() {
   sortUsingNestedText($('.result_search'), ".s_li", $(this).data("sortKey"));
});
  
  //
  $('.selected_sort').click(function(){
  	var sort_options = $('#sort-options');
    if(sort_options.is(':hidden')){
    	sort_options.slideDown();
    }else {
    	sort_options.slideUp();
    }
  });
  
  // Click sort by ==> Event
  $('#sort-options li a').click(function(){
  	var name_ = $(this).text();
    var val_ = $(this).attr('id');
    $('.selected_sort').text(name_);
    // add sort to pagination
    $('.pagination-custom li').each(function(){
    	var href_ = $(this).find('a').attr('data-url');
      	$(this).find('a').attr('href', href_ + '&sort=' + val_ );
    })
  });
  // Function get url param.
  $.urlParam = function(name){
      var url = window.location.href;
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url);
      if(results) {
        return results[1] || 0;
      }
  }
  var sort = $.urlParam('sort');
  // Trigger click if sort by ...
  if(typeof sort != 'undefined'){
    $('#sort-options li').each(function(){
		var trigger_id = $(this).find('a').attr('id');
      if(trigger_id == sort){
      	$(this).find('a').trigger('click');
      }
    })
  }
  // Event hide dropdow
  $(document).mouseup(function (e)
    {
        var container = $("#sort-options");
        if (!container.is(e.target) 
            && container.has(e.target).length === 0) 
        {
            container.hide();
        }
    });
  // Number Show on Collection
  $('#show_number').change(function(e){
      e.preventDefault();
      Shopify.queryParams.view = $(this).val();
      location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
    });
  // Check exists
  $.urlParam = function(name){
    var url = window.location.href;
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url);
    if(results) {
      return results[1] || 0;
    }
  }
  var view = $.urlParam('view');
  if(typeof view != 'undefined'){
    $('#show_number').val(view);
  }
  // Up down input number
  $(".w_number span").on("click", function() {

    var $button = $(this);
    var oldValue = $button.parent().find("input").val();

    if ($button.attr('class') == "up_") {
        var newVal = parseFloat(oldValue) + 1;
      } else {
     // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }

    $button.parent().find("input").val(newVal);

  });
  // Search bar
  $('#search_ar').submit(function(){
  	var val_search = $('.val_search').val();
    if(val_search == ''){
    	return false;
    }else {
    	$('.header-bar__search-input').val(val_search);
    }
    
  });
  
  // Fancybox Send email
  //$('.product-single h1').click(function(){
    //$.fancybox({
            //'content' : $(".send_mail").html()
        //});
  //});
    $('.product-single .social-sharing .email__ a').click(function(){
      $('#myModal_share').modal();
    });
  	$(document).on('click','.s_email .email__ a',function(){
      var id_product = $(this).attr('data-id');
      var shop_url = $(this).attr('data-shop');
      var shop_domain = $(this).attr('data-shop');
      $.ajax({
        url: "/apps/TellAFriend?shop="+shop_domain+"&product_id="+id_product+"&shop_url="+shop_url, 
        success: function(data){
          $("#TellAFriend").html(data);
          $("#TellAFriend").find('input[name="productId"]').val(id_product);
          $("#TellAFriend").find('input[name="shop_url"]').val(shop_url);
          $('#myModal_share').modal();
      }});
      
    });
  // Youtube embed product
  
  // Disable event click img product zoom
  $(document).on('click','#ProductPhoto img',function(e){
  	e.preventDefault();
  })
  
  $(window).on('load', function(){
    if($.cookie("allowage1") != 'undefined'){
      	if($.cookie("allowage1") != '1'){
    		$("#ageModal").modal('show');
        }
    }else{
      $("#ageModal").modal('show');
    }
  });
  // Process Popup question Age
    $('.alert_age .yes_btn').click(function(){
      	var check_remember = $('.alert_age #remember_');
      if(check_remember.is(':checked') == true){
      	//$.cookie('age_allow', '1');
        var date = new Date();
        //var minutes = 2; 
        date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
        $.cookie("allowage1", "1", { expires: date, path: '/'});
      } else{
        var date = new Date();
        //var minutes = 2; 
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
        $.cookie("allowage1", "1", { expires: date, path: '/'});
      }
      $(".modal-backdrop").removeClass('show');
      $("body").css('overflow','initial;');
    })
    if($.cookie("allowage1") != 'undefined' && $('.template-index').length){
      	if($.cookie("allowage1") != '1'){
    		$("#ageModal").modal({backdrop: 'static', keyboard: false});
        }
    }

    // $(document).on('click', function(e) {
    //   var popup = $('#ageModal');
    //   if (!popup.is(e.target) && popup.has(e.target).length === 0) {
    //     // Clicked outside the popup
    //     e.preventDefault();
    //     return false;
    //   }
    // });
 
  	
  // Menu mobile
  $(document).on('click','.up_down span',function(){
  	var sub = $(this).closest('.mobile-nav__link').find('.mobile-nav__sublist');
    $(this).closest('.up_down').toggleClass('active__');
    if(sub.is(':hidden')){
    	sub.slideDown();
    }else {
    	sub.slideUp();
    }
  });
  
  $('.site-nav--has-dropdown .icon_sub').on('click', function(){
    console.log(1);
    var fa = $(this).parent();
    if(fa.hasClass('open')){
      fa.removeClass('open');
    }else{
      fa.addClass('open');
    }
  });
  // $(window).on('load', function(){
  //   console.log($('.icon_subsub').length,'count');
  // });
  $('.site-nav--has-dropdown .icon_subsub').on('click', function(){
    console.log(2);
    var subsub = $(this).parent();
    if(subsub.hasClass('open')){
      subsub.removeClass('open');
    }else{
      subsub.addClass('open');
    }
  });
  
  // Process Empty cart
    // if(!$.cookie("cart_empty")){
    //       clearCart ();
    // }else {
    // }
})
// Function Emptycart
function clearCart (){
	$.ajax({
    	type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() { 
        }
    })
    return false;
}
